import React from 'react'
import {Navigation} from '../components/Navigation'
import {Placeholder, Label, Table, Button, Icon, Card, Transition, Loader} from 'semantic-ui-react'
import { useSelector } from 'react-redux'
import { useFirestore, useFirestoreConnect } from 'react-redux-firebase'
import {Route} from '../components/Router.js'
import { Events } from '../components/events';

export default function Mobileapp() {
  return (
    <Navigation title="Events" icon="soccer" menu={
        [
            {
                caption: 'Events',
                icon: 'soccer',
                active: true
            }
        ]
    }>
        <Route path="/events/*" exact={true} component={Events} />
    </Navigation>
  )
}